import { assign } from '../../../../lib/assign';
import {
    userForbiddenInfoHide,
    userForbiddenInfoShow,
    userLoadComplete,
    userNotificationConnected,
    userNotificationConnecting,
    userNotificationDiscnnected, userSessionLoadComplete, userSettingsAddToDirectory,
    userSettingsCreateNewFilterDirectory, userSettingsDeleteDirectory, userSettingsDeleteFromDirectory,
    userSettingsEditDirectoryName,
    userSettingsLoadEnd, userSettingsSaved, userSettingsSaveFailed, userSettingsSelectFilterDirectory
} from './user.actions';
import { NotificationConnectionState, UserState } from './user.model';
import { createReducer, on } from '@ngrx/store';
import { v4 as Guid } from 'uuid';
import { FilterDirectory } from '../../../common/model/WK.Ladon.Cms.Read.Queries.User.Model.FilterDirectory';

const INITIAL_STATE: UserState = {
    personalSettings: null,
    personalSettingsErrorCode: null,
    user: null,
    notifications: {
        connectionState: NotificationConnectionState.disconnected,
        list: []
    },
    showForbiddenInfo: false,
    sessionInfo: null
};

export const userReducer = createReducer(
    INITIAL_STATE,
    on(userLoadComplete, (state, {user}) => assign(state, {user: user})),
    on(userSessionLoadComplete, (state, {sessionInfo}) => assign(state, {sessionInfo: sessionInfo})),
    on(userNotificationConnected, (state) => assign(state, {notifications: assign(state.notifications, {connectionState: NotificationConnectionState.connected})})),
    on(userNotificationConnecting, (state) => assign(state, {notifications: assign(state.notifications, {connectionState: NotificationConnectionState.pending})})),
    on(userNotificationDiscnnected, (state) => assign(state, {notifications: assign(state.notifications, {connectionState: NotificationConnectionState.disconnected})})),
    on(userForbiddenInfoShow, (state) => ({...state, showForbiddenInfo: true})),
    on(userForbiddenInfoHide, (state) => ({...state, showForbiddenInfo: false})),
    on(userSettingsCreateNewFilterDirectory, (state, {newFilterDirectory}) => {
        if (newFilterDirectory) {
            return assign(state, {
                personalSettings: assign(state.personalSettings, {
                    //timestamp: state.personalSettings.timestamp,
                    filterDirectories: [...state.personalSettings.filterDirectories, newFilterDirectory]
                })
            });
        }
    }),
    on(userSettingsEditDirectoryName, (state, {id, name}) => {
        if (id) {
            const item: FilterDirectory = state.personalSettings.filterDirectories.find(x => x.id === id);
            const clone: FilterDirectory[] = [...state.personalSettings.filterDirectories.filter(x => x.id !== id)];
            const directory: FilterDirectory = assign(item, {
                name: name
            });
            return assign(state, {
                personalSettings: assign(state.personalSettings, {
                    //timestamp: state.personalSettings.timestamp,
                    filterDirectories: [...clone, directory]
                })
            });
        }
    }),
    on(userSettingsDeleteDirectory, (state, {id}) => {
        if (id) {
            const clone = [...state.personalSettings.filterDirectories.filter(x => x.id !== id)];
            return assign(state, {
                personalSettings: assign(state.personalSettings, {
                    //timestamp: state.personalSettings.timestamp,
                    filterDirectories: [...clone],
                    selectedDirectoryId: null
                })
            });
        }
    }),
    on(userSettingsAddToDirectory, (state, {id, filterId}) => {
        if (id && filterId) {
            const filterDirectoriesClone: FilterDirectory[] = [...state.personalSettings.filterDirectories.filter(x => x.id !== id)];
            const directory: FilterDirectory = state.personalSettings.filterDirectories.find(x => x.id === id);
            if (directory && !directory.filterIds.find(x => x.valueOf() === filterId)) {
                const directoryClone: FilterDirectory = assign(directory, {
                    filterIds: [...[...directory.filterIds], filterId]
                });
                return assign(state, {
                    personalSettings: assign(state.personalSettings, {
                        //timestamp: state.personalSettings.timestamp,
                        filterDirectories: [...filterDirectoriesClone, directoryClone]
                    })
                });
            }
        }
        return state;
    }),
    on(userSettingsDeleteFromDirectory, (state, {id, filterId}) => {
        if (id && filterId) {
            const filterDirectoriesClone: FilterDirectory[] = [...state.personalSettings.filterDirectories.filter(x => x.id !== id)];
            const directory: FilterDirectory = state.personalSettings.filterDirectories.find(x => x.id === id);
            if (directory) {
                const directoryClone: FilterDirectory = assign(directory, {
                    filterIds: [...directory.filterIds.filter(x => x !== filterId)]
                });
                return assign(state, {
                    personalSettings: assign(state.personalSettings, {
                        //timestamp: state.personalSettings.timestamp,
                        filterDirectories: [...filterDirectoriesClone, directoryClone]
                    })
                });
            }
        }
        return state;
    }),
    on(userSettingsSelectFilterDirectory, (state, {id}) => {
        return assign(state, {
            personalSettings: assign(state.personalSettings, {
                selectedDirectoryId: id
            })
        });
    }),
    on(userSettingsSaved, (state, {timestamp}) => {
        return assign(state, {
            personalSettings: assign(state.personalSettings, {
                timestamp: timestamp
            })
        });
    }),
    on(userSettingsSaveFailed, (state, {errorCode}) => {
        return assign(state, {
            personalSettingsErrorCode: errorCode
        });
    }),
    on(userSettingsLoadEnd, (state, {personalSettings}) => {
        if (personalSettings?.filterDirectories?.length > 0) {
            return assign(state, {
                    personalSettings:
                        assign(state.personalSettings, {
                            filterDirectories: personalSettings.filterDirectories,
                            timestamp: personalSettings.timestamp
                        })
                }
            );
        } else {
            const root: FilterDirectory = {
                id: Guid(),
                parentId: null,
                ordinal: 1,
                name: 'wszystkie filtry',
                filterIds: []
            };
            return assign(state, {
                personalSettings: {
                    filterDirectories: [root],
                    timestamp: null
                }
            });
        }
    })
);